import React from "react";
import MainTemplate from "../../../components/MainTemplate/MainTemplate";
import CardBackground from "../../../components/MainTemplate/CardBackground";
import SalaryListChild from "./SalaryListChild";

const SalaryList = () => {
  return (
    <MainTemplate>
      <CardBackground>
        <SalaryListChild />
      </CardBackground>
    </MainTemplate>
  );
};
export default SalaryList;

